import { useEffect, useState, useRef } from "react";
import Select from "react-select";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import apiInstance from "../../utils/axios";
import useAxios from "../../utils/useAxios";
import { REACT_APP_BASE_URL } from "../../utils/constant";
import UserData from "../plugins/UserData";
import '../../../css/productIngredients.css';
import '../../../css/dashboard.css';
import { Link, useNavigate } from "react-router-dom";
import { useAuthApp } from '../../app/auth';
import { useTranslation } from 'react-i18next';
import QRCodeStyling from "qr-code-styling";
import QRCodeOptionsModal from "../../components/QRCodeOptionsModal";
import { logout } from '../../utils/auth';


const Toast = Swal.mixin({
    toast: true,
    position: "top",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
});


function Dashboard() {
    const [products, setProducts] = useState([])
    const [searchTerm, setSearchTerm] = useState("");
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(true);
    // Modal related states
    const [qrModalOpen, setQrModalOpen] = useState(false);
    const [qrProduct, setQrProduct] = useState(null);
    const [userLogoUrl, setUserLogoUrl] = useState(null);
    const [qrValue, setQrValue] = useState("");
    const [logoAvailable, setLogoAvailable] = useState(false);

    const navigate = useNavigate()
    const api = useAxios();

    const isLoggedIn = useAuthApp((state) => state.isLoggedIn)
    const userData = useAuthApp((state) => state.user)
    const userId = userData()?.user_id

    let lang_browser = navigator.language.toLowerCase();
    let lang = localStorage.getItem('language') || (lang_browser.startsWith("en") ? "en" : lang_browser);


    const handleOpenQRModal = async (product) => {
        try {
            const response = await apiInstance.get(`hash-id/${product.id}/`);
            const hashedId = response.data.hashed_id;
            setQrValue(`${REACT_APP_BASE_URL}/product-overview/${hashedId}/`);

            // Fetch user profile image
            const response_user = await apiInstance.get(`user/${userId}/`);
            const image = response_user.data.winefactsprofile.img_qr_code;
            setLogoAvailable(!!image);
                  
            if (!image) {
                Toast.fire({
                    icon: "info",
                    title: t("userProfile.messages.qrImageNotFound") || "QR code image could not be retrieved.",
                });
            } else {
                setUserLogoUrl(image);
            }

            setQrProduct(product);
            setQrModalOpen(true);
        } catch (err) {
            console.error("Error fetching QR modal data:", err);
            Toast.fire({
                icon: "error",
                title: t("userProfile.messages.qrImageFetchError") || "Error fetching QR code image.",
            });
        }
    };

    const handleDownloadQRStyled = async (product, format="png") => {
        try {
            const response = await apiInstance.get(`hash-id/${product.id}/`);
            const hashedId = response.data.hashed_id;
            const qrValue = `${REACT_APP_BASE_URL}/product-overview/${hashedId}/`;
            const response_user = await apiInstance.get(`user/${userId}/`)
            const image = response_user.data.winefactsprofile.img_qr_code


            const qrCode = new QRCodeStyling({
                width: 1200,
                height: 1200,
                data: qrValue,
                image: image,
                imageOptions: {
                    crossOrigin: "anonymous", // Needed if logo is from another domain
                    margin: 1,
                    imageSize: 0.40, // 25% of QR code area
                },
                dotsOptions: {
                    color: "black", //"#222",
                    type: "rounded"
                },
                backgroundOptions: {
                    color: "#fff", //"transparent", //"#fff"
                },
                cornersSquareOptions: {
                    color: "black", //"#8B0000",
                    type: "extra-rounded"
                }
            });

            // Create a temporary DOM node to render the QR code
            const tempDiv = document.createElement("div");
            document.body.appendChild(tempDiv);

            // Append QR code to the temp div
            await qrCode.append(tempDiv);

            // Download as PNG
            qrCode.download({
                name: `${product.product_name}_qr`,
                extension: format
            });

            // Clean up
            setTimeout(() => {
                document.body.removeChild(tempDiv);
            }, 1000);

        } catch (err) {
            console.error("QR code generation failed", err);
            Toast.fire({
                icon: "error",
                title: t("product.form.messages.qrGenerationError"),
            });
        }
    };

    
    const fetchProducts = async () => {
        if (!api) return;
        try {
            setIsLoading(true)
            const res = await api.get('products/', {headers: { "Accept-Language": `${lang}` }})
            if (res && res.status === 200) {
                setProducts(res.data);
            }
            
        } catch (error) {
            console.log(error)
            Toast.fire({
                icon: "error",
                title: "Error in fetching the data - please login",
            })
        } finally {
            setIsLoading(false)
        }
        }


    useEffect(() => {
        if (api) {
            fetchProducts()
        }
        
    },[api,lang])

    
    // const handleDelete = async (e,p) => {
    //     if (!api) return;
    //     e.preventDefault();
    //     const result = await Swal.fire({
    //                 title: `${t("product.form.headingDeletionPopup")}: ${p.product_name}`,
    //                 text: t("product.form.messages.deletionDescription"),
    //                 icon: "warning",
    //                 showCancelButton: true,
    //                 confirmButtonColor: "#d33",
    //                 cancelButtonColor: "#3085d6",
    //                 confirmButtonText: t("productNameManagement.buttons.delete"),
    //                 cancelButtonText: t("productNameManagement.buttons.cancel"),
    //                 customClass: {
    //                     popup: "custom-popup-class",
    //                     confirmButton: "custom-confirm-button-class",
    //                     cancelButton: "custom-cancel-button-class",
    //                 },
    //             });

    //     if (result.isConfirmed) {
    //         api
    //             .delete(`/products/${p.id}/`)
    //             .then(() => {
    //             // fetchProducts();
    //              setProducts(prev => prev.filter(prod => prod.id !== p.id)); // Remove from state directly
    //             })
    //             .catch((error) => {
    //             console.error('Error deleting product:', error);
    //             Toast.fire({
    //                 icon: "error",
    //                 title: t("product.form.messages.deleteError"),
    //             });
    //             })
    //             .finally(() => {
    //                 Toast.fire({
    //                     icon: "success",
    //                     title: t("product.form.messages.deleteSuccess"),
    //                 });
    //             })
    //     }
    // };

    const handleDelete = async (e, p) => {
        if (!api) return;
        e.preventDefault();

        const { value: typed } = await Swal.fire({
            title: `${t("product.form.headingDeletionPopup")}: ${p.product_name}`,
            html: `
                <p>${t("product.form.messages.deletionDescription")}</p>
                <input id="swal-input-confirm" class="swal2-input" placeholder="${t("productNameManagement.labels.typeConfirmToDelete") || "Type 'DELETE' or 'LÖSCHEN' to enable delete"}" />`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: t("productNameManagement.buttons.delete"),
            cancelButtonText: t("productNameManagement.buttons.cancel"),
            customClass: {
                popup: "custom-popup-class",
                confirmButton: "custom-confirm-button-class",
                cancelButton: "custom-cancel-button-class",
            },
            didOpen: () => {
                const popup = Swal.getPopup();
                if (!popup) return;
                const input = popup.querySelector('#swal-input-confirm');
                const confirmBtn = Swal.getConfirmButton();
                confirmBtn.disabled = true;
                input.addEventListener('input', () => {
                    const value = input.value.trim().toLowerCase();
                    confirmBtn.disabled = (value !== 'delete' && value !== 'löschen');
                });
                input.focus();
            },
            preConfirm: () => {
                const popup = Swal.getPopup();
                const input = popup ? popup.querySelector('#swal-input-confirm') : null;
                const value = input ? input.value.trim().toLowerCase() : '';

                if (value !== 'delete' && value !== 'löschen') {
                    Swal.showValidationMessage(t("productNameManagement.labels.typeConfirmToDelete") || 'Type "DELETE" or "LÖSCHEN" to delete');
                    return false;
                }
                return input.value;
            }
        });

        if (!typed) return; // User canceled or didn't type confirm

        try {
            const response = await api.delete(`/products/${p.id}/`);
            if (response.status === 204) {
                Toast.fire({
                    icon: "success",
                    title: t("product.form.messages.deleteSuccess"),
                });
                setProducts(prev => prev.filter(prod => prod.id !== p.id)); // Remove from state directly
            }
        } catch (error) {
            console.error("Error deleting product:", error);
            Toast.fire({
                icon: "error",
                title: t("product.form.messages.deleteError"),
            });
        }
    };

    
    const handleDownload = async (id) => {
        try {
            const response = await apiInstance.get(`/products/${id}/download_qr_code/`, {
                responseType: "blob", // Important: Ensure we receive a file (binary data)
            });
    
            // Create a blob from the response
            const blob = new Blob([response.data], { type: response.headers["content-type"] });
            const url = window.URL.createObjectURL(blob);
    
            // Create a temporary link & trigger download
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `qr_code_${id}.png`); // Adjust filename if needed
            document.body.appendChild(link);
            link.click();
    
            // Clean up
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error downloading QR code:", error);
        }
    };

    const handleNavigate = async (id) => {
        const response = await apiInstance.get(`hash-id/${id}/`)
        const hashedId = response.data.hashed_id;
        navigate(`/update-product/${hashedId}/`)

    }

    const handleDetails = async (id) => {
        const response = await apiInstance.get(`hash-id/${id}/`)
        const hashedId = response.data.hashed_id;
        navigate(`/product-overview/${hashedId}/`)

    }

    // Function to filter products based on search input
    const filteredProducts = products.filter((p) =>
        Object.values(p).some((value) => {
        if (typeof value === "string") {
            return value.toLowerCase().includes(searchTerm.toLowerCase());
          }
          if (typeof value === "number") {
            return value.toString().includes(searchTerm); // Convert number to string for searching
          }
          if (Array.isArray(value)) {
            return value.join(", ").toLowerCase().includes(searchTerm.toLowerCase());
          }
          return false;
        })
    );
    
  return (
    <>
        <div className="container-1">
            <h1 className="m-b25r-b25b-b25l">Dashboard</h1>
            {isLoading ? (
                <div style={{ textAlign: "center", margin: "2rem" }}>
                    <i className="fas fa-spinner fa-spin" style={{ fontSize: "2rem" }}></i>
                </div>
                ) : products.length > 0 ? (
                <div>
                    <div className='form-input-container-2  p-b25r-b25b-b25l'>
                        <label className="form-label-2" htmlFor="product-name-search">Search Products:</label>
                        <input
                            type="text"
                            id="searchInput"
                            placeholder="Classic ..."
                            className="form-input-1 w25 mw200p"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <div className="table-container">
                        <table className="product-table">
                            <thead>
                                <tr>
                                    <th className="col-fixed">{t("tableHeaders.productName")}</th>
                                    <th className="col-disable">{t("tableHeaders.wineTypes")}</th>
                                    <th className="col-disable">{t("tableHeaders.origin")}</th>
                                    <th className="col-disable">{t("tableHeaders.wineQuality")}</th>
                                    <th>{t("tableHeaders.vintage")}</th>
                                    <th className="col-disable">{t("tableHeaders.wineStyle")}</th>
                                    <th className="col-disable">{t("tableHeaders.blending")}</th>
                                    <th>{t("tableHeaders.qrCode")}</th>
                                    <th>{t("tableHeaders.details")}</th>
                                    <th>{t("tableHeaders.update")}</th>
                                    <th>{t("tableHeaders.delete")}</th>
                                </tr>
                            </thead>
                            <tbody>
                            {filteredProducts.map((p) => (
                                <tr key={p.id}>
                                    <td className="col-fixed">{p.product_name}</td>
                                    <td className="col-disable">{p.wine_type.join(",")}</td>
                                    <td className="col-disable">{p.origin}</td>
                                    <td className="col-disable">{p.wine_qual}</td>
                                    <td>{p.vintage}</td>
                                    <td className="col-disable">{p.sub_category}</td>
                                    <td className="col-disable">{p.blending_type}</td>
                                    <td>
                                        <button
                                            className="btn-table-1 btn-dw-c"
                                            style={{width: "170px"}}
                                            onClick={() => handleOpenQRModal(p)}
                                            >
                                            {t("tableHeaders.customQrCode")}
                                        </button>
                                        <button
                                            style={{marginTop: "5px", width: "170px"}}
                                            className="btn-table-1 btn-dw-c"
                                            onClick={() => handleDownloadQRStyled(p)}
                                            >
                                            {t("tableHeaders.defaultQrCode")}
                                        </button>
                                    </td>
                                    <td>
                                        <button
                                            className="btn-table-1 btn-dt-c"
                                            onClick={() => handleDetails(p.id)}
                                            >
                                            {t("detailsButton")}
                                        </button>
                                    </td>
                                    <td>
                                        <button
                                        onClick={() => handleNavigate(p.id)}
                                        className="btn-table-1 btn-u-c"
                                        >
                                        {t("updateButton")}
                                        </button>
                                    </td>
                                    <td>
                                        <button
                                        type="button"
                                        className="btn-table-1  btn-d-c"
                                        onClick={(e) => handleDelete(e,p)}
                                        >
                                        {t("deleteButton")}
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>)
               : (
                 !isLoading && <p className="no-products-message">{t("noProductsMessage")}</p>
                )
            }
        </div>
        <QRCodeOptionsModal
            isOpen={qrModalOpen}
            onRequestClose={() => setQrModalOpen(false)}
            userLogoUrl={userLogoUrl}
            defaultOptions={{
                width: 1200,
                height: 1200,
                dotColor: "black",
                bgColor: "transparent",
                cornerColor: "black",
                useLogo: true,
                logoSize: 0.4,
            }}
            qrValue={qrValue}
            logoAvailable={logoAvailable}
        />
    </>
  )
}

export default Dashboard